Object.defineProperty(exports, "__esModule", { value: true });
function Commas(n) {
    return n.toLocaleString("en-US");
}
exports.default = Commas;
